import { create } from "zustand";

type ModalType = "settings" | "profile" | "create-server" | null;

interface ProfileData {
  userId: string;
  displayName: string;
  username: string;
  createdAt?: string;
  isAdmin?: boolean;
}

interface ModalState {
  activeModal: ModalType;
  profileData: ProfileData | null;
  openModal: (modal: ModalType, data?: ProfileData) => void;
  closeModal: () => void;
}

export const useModalStore = create<ModalState>((set) => ({
  activeModal: null,
  profileData: null,
  openModal: (modal, data) =>
    set({ activeModal: modal, profileData: data ?? null }),
  closeModal: () =>
    set({ activeModal: null, profileData: null }),
}));
